import RCSlider, { SliderProps } from "rc-slider";
import "rc-slider/assets/index.css";

const Slider: React.FC<SliderProps> = (props) => {
  return <RCSlider {...props} />;
};
export default Slider;
